(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('price-facet-component').forEach(function(pfc) {
    const minInput = pfc.querySelector('input[ref="minInput"]');
    const maxInput = pfc.querySelector('input[ref="maxInput"]');
    if (!minInput || !maxInput) return;

    const absMaxRaw = parseFloat(maxInput.getAttribute('data-max') || '0');
    const absMax = Math.round(absMaxRaw * 1000);

    function parseVal(input) {
      const raw = input.value.replace(',', '.').trim();
      return raw === '' ? null : parseFloat(raw);
    }

    // Validate on blur (when user leaves the field) — before Horizon's change fires
    minInput.addEventListener('blur', function() {
      const minVal = parseVal(minInput);
      if (minVal === null) return;
      if (minVal < 0) minInput.value = 0;
      if (minVal > absMax) minInput.value = absMax;
      const maxVal = parseVal(maxInput);
      if (maxVal !== null && minVal > maxVal) minInput.value = maxVal;
    });

    maxInput.addEventListener('blur', function() {
      const maxVal = parseVal(maxInput);
      if (maxVal === null) return;
      if (maxVal > absMax) maxInput.value = absMax;
      if (maxVal < 0) maxInput.value = 0;
      const minVal = parseVal(minInput);
      if (minVal !== null && maxVal < minVal) maxInput.value = minVal;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
